import { render } from "./PartnersListView.vue?vue&type=template&id=063e7730"
import script from "./PartnersListView.vue?vue&type=script&lang=js"
export * from "./PartnersListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__